import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

export interface ClassroomView {
  kind: 'lesson' | 'loading' | 'exam'
  examId?: number
  userExamId?: number
  phase?: string
  questionIds?: number[]
  questionNumber?: number
}

export function useClassroomPractice() {
  const route = useRoute()
  const practiceDiscussion = ref<{ attemptId: number; requestId: number } | null>(null)
  let discussionSequence = 0
  function discussPractice(attemptId: number) {
    practiceDiscussion.value = { attemptId, requestId: ++discussionSequence }
    const toggle = document.querySelector('[data-bs-target="#ai_chat"]') as HTMLElement | null
    if (window.innerWidth < 700) toggle?.click()
  }
  const practiceExamId = ref<number | null>(null)
  const practiceGenerating = ref(false)
  const practiceProgress = ref({ progress: 5, stage: '作成を開始しています' })
  const showPractice = ref(false)
  const practiceView = ref<ClassroomView | null>(null)
  const lessonExamView = ref<ClassroomView | null>(null)
  const activeView = computed<ClassroomView>(() => showPractice.value
    ? practiceGenerating.value ? { kind: 'loading' } : practiceView.value || { kind: 'loading' }
    : lessonExamView.value || { kind: 'lesson' })
  const practiceTaking = computed(() => showPractice.value && !['result', 'review'].includes(activeView.value.phase || ''))
  function setPracticeView(view: ClassroomView) { if (view.examId === practiceExamId.value) practiceView.value = view }
  function setLessonExamView(view: ClassroomView) { lessonExamView.value = view }
  const practiceHistoryRevision = ref(0)
  function refreshPracticeHistory() { practiceHistoryRevision.value++ }
  watch(() => [route.params.courseId, route.query.lesson_id, route.query.thread_id], () => {
    practiceView.value = null
    lessonExamView.value = null
    practiceDiscussion.value = null
    practiceExamId.value = null
    showPractice.value = false
    practiceGenerating.value = false
  }, { immediate: true })
  function setLatestPractice(result: { examId: number }) { if (!practiceExamId.value) practiceExamId.value = result.examId }
  function openPractice(result: { examId: number }) {
    if (practiceExamId.value !== result.examId) practiceView.value = null
    practiceExamId.value = result.examId
    practiceGenerating.value = false
    showPractice.value = true
    const modal = document.querySelector('#ai_chat.show [data-bs-dismiss="modal"]') as HTMLElement | null
    modal?.click()
  }
  let visibleBeforeGeneration = false
  function onPracticeGenerating(value: boolean) {
    if (value) {
      visibleBeforeGeneration = showPractice.value
      practiceGenerating.value = true
      showPractice.value = true
    } else if (practiceGenerating.value) {
      // openPractice clears generating on success; a failure restores the prior view.
      practiceGenerating.value = false
      showPractice.value = visibleBeforeGeneration
    }
  }
  function returnToLesson() { showPractice.value = false }
  function onPracticeProgress(value: { progress: number; stage: string }) { practiceProgress.value = value }
  return { activeView, practiceTaking, setPracticeView, setLessonExamView, practiceDiscussion, discussPractice, practiceHistoryRevision, refreshPracticeHistory, practiceExamId, practiceGenerating, practiceProgress, showPractice, openPractice, setLatestPractice, onPracticeGenerating, onPracticeProgress, returnToLesson }
}
